import React, { Component } from "react";
import AppContext from "../../contexts/AppContext";
import { invoice } from './../../services/billing';

class Intercom extends Component {
    intercom = () => {
        let blockLocation = [
            '/writer/messages/',
            '/employer/messages/',
            '/admin/messages/'
        ]

        for (let index = 0; index < blockLocation.length; index++) {
            const location = blockLocation[index];
            if ( this.props.location.pathname.indexOf( location ) != -1 ){
                return false ;
            }
        }

        if (this.context.state.user) {
            window.intercomSettings = {
                app_id: "a4yp9kr8",
                name: `${this.context.state.user.first_name} ${this.context.state.user.last_name}`,
                email: this.context.state.user.email,
                role: this.context.state.user.type,
                verified:  (this.context.state.user.state === 'applied') ? "pending" : this.context.state.user.state ,
                email_verified: this.context.state.user.email_verified,
                completed:
                    this.context.state.user.state === "completed" ||
                        this.context.state.user.state === "approved"
                        ? true
                        : false,
                quiz_result:
                    this.context.state.user.quiz === "failure"
                        ? "retake"
                        : this.context.state.user.quiz === "passed"
                            ? "passed"
                            : "pending", //'ready','running','failure','passed','time-out','lost-focus'
                subscription: this.context.state.user.plan
                    ? this.context.state.user.plan.main === "true"
                        ? false
                        : true
                    : "other",
                created_at: Math.floor(Date.now() / 1000)
            };

            var w = window;
            var ic = w.Intercom;
            if (typeof ic === "function") {
                ic("reattach_activator");
                ic("update", w.intercomSettings);
            } else {
                var i = function () {
                    i.c(arguments);
                };
                i.q = [];
                i.c = function (args) {
                    i.q.push(args);
                };
                w.Intercom = i;
            }
            var l = () => {
                var s = document.createElement("script");
                s.type = "text/javascript";
                s.async = true;
                s.defer = true;
                s.src = "https://widget.intercom.io/widget/a4yp9kr8";
                var x = document.getElementsByTagName("script")[0];
                x.parentNode.insertBefore(s, x);
            };
            // if (w.attachEvent) {
            //     w.attachEvent("onload", l);
            // } else {
            //     w.addEventListener("load", l, false);
            // }
        }
    };

    render() {
         return <div></div>;
    }
}

Intercom.contextType = AppContext;
export default Intercom;



// WEBPACK FOOTER //
// ./src/components/auth/Intercom.js